<template>
  <v-toolbar
    :color="isTransparentHeaderbar ? '' : 'white'"
    :class="'header black--text elevation-1 ' + (isTransparentHeaderbar ? 'is-transparent' : '')"
    app
    fixed
  >
    <v-toolbar-side-icon
      v-if="isMobile && !backButtonVisible"
      @click.native="changeNavicationMini"
    ></v-toolbar-side-icon>
    <v-toolbar-title v-if="!isTransparentHeaderbar">
      <p class="pa-0 ma-0" v-if="pageTitleVisible">
        <v-btn
          class="ma-0 pa-0 mr-2 back-btn"
          flat
          icon
          color="dark"
          v-if="backButtonVisible"
          :to="breadcrumbs[0].to"
        >
          <v-icon class="accent--text">arrow_back</v-icon>
        </v-btn>
        <span class="d-inline-block" style="vertical-align: middle">{{ pageTitle }}</span>
      </p>

      <v-breadcrumbs v-if="!pageTitleVisible">
        <v-icon slot="divider">chevron_right</v-icon>
        <v-breadcrumbs-item
          v-for="item in breadcrumbs"
          :to="item.to"
          :key="item.text"
          class="title grey--text text--darken-4"
        >
          <span v-if="item.text">{{ item.text }}</span>
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <router-link v-if="signinButtonVisible" :to="{ name: 'sign-in' }" style="text-decoration: none">
      <v-btn flat color=" grey--text text--darken-3" class="elevation-0 text-transform-initial">
        <v-icon color="grey darken-2" class="mr-2">account_circle</v-icon>
        {{ $t('page.sign_in') }}
      </v-btn>
    </router-link>
    <!-- <DownloadingExportOrder /> -->

    <v-menu bottom offset-y v-if="token && !isMobile">
      <v-btn depressed slot="activator" color="grey lighten-3" icon @click="showOrderTimeline">
        <v-icon>timeline</v-icon>
      </v-btn>
      <div class="order--timeline">
        <OrdersTimeline v-if="loadOrderTimeline" />
      </div>
    </v-menu>

    <v-tooltip bottom v-if="token">
      <v-btn depressed slot="activator" color="grey lighten-3" icon @click="gotoAhamove">
        <img src="/assets/favico/android-icon-96x96.png" alt="Ahamove" width="22" />
      </v-btn>
      <span>{{ $t('partner.ahamove_icon_hint') }}</span>
    </v-tooltip>
  </v-toolbar>
</template>

<script>
import OrdersTimeline from '@/components/OrdersTimeline'
// import DownloadingExportOrder from '@/components/records/DownloadingExportOrder'

export default {
  name: 'Header',
  components: {
    OrdersTimeline
    // DownloadingExportOrder
  },
  props: ['app', 'pageTitle'],
  data() {
    return {
      mini: true,
      loadOrderTimeline: false
    }
  },
  computed: {
    breadcrumbs() {
      let result = []
      if (this.$route && this.$route.name) {
        switch (this.$route.name) {
          case 'record_detail':
            result = [
              {
                text: this.$t('page.booking'),
                back_button: true,
                to: { name: 'booking' }
              }
            ]
            break
          default:
            result.push({
              text: this.$t('page.' + this.$route.name)
            })
            break
        }
      }

      return result
    },
    pageTitleVisible() {
      return this.breadcrumbs.length <= 1
    },
    backButtonVisible() {
      return this.breadcrumbs && this.breadcrumbs[0] && this.breadcrumbs[0].back_button
    },
    token: {
      cache: false,
      get() {
        return this.$store.getters.token
      }
    },
    profile: {
      cache: false,
      get() {
        return this.$store.getters.userProfile
      }
    },
    navigationMini() {
      return this.$store.getters.navigationMini
    },
    isTransparentHeaderbar() {
      // return this.isMobile && this.$route && this.$route.name === 'new_order'
      return false
    },
    signinButtonVisible: {
      cache: false,
      get() {
        return !this.$store.getters.token && !this.isMobile && true
      }
    },
    orderTimelineVisible() {
      // TODO
      return this.token && process.env.NODE_ENV !== 'production'
    }
  },
  methods: {
    changeNavicationMini() {
      if (this.isMobile) {
        this.$store.dispatch('setNavigationDrawer', true)
      } else {
        const value = !this.navigationMini
        this.$store.dispatch('setNavigationMini', value)
      }
    },
    showOrderTimeline() {
      this.loadOrderTimeline = true
      this.$analyticTracking.logEvent(
        this.$trackingEvents.ACTIONS.CLICK,
        this.$trackingEvents.EVENTS.HEADER_TIMELINE_BTN,
        {}
      )
    },
    gotoAhamove() {
      window.open(process.env.VUE_APP_BASE_URL, '_blank')
    }
  },
  beforeMount() {}
}
</script>
<style lang="scss" scoped>
.order--timeline {
  height: 70vh;
  width: 400px;
  position: relative;
}

.header {
  box-shadow: none !important;
  border-bottom: 1px solid #cfcfcf !important;
  z-index: 3;
  // box-shadow: 0 2px 4px rgba(0,0,0,0.2),0 -1px 0px rgba(0,0,0,0.02);
}

.v-toolbar__title {
  overflow: visible;

  .back-btn {
    margin-left: -9px !important;
  }
}
</style>

<style lang="scss">
.mdc-toolbar__menu {
  text-decoration: none;
  color: white;
  cursor: pointer;
  padding-right: 8px;
}

.truck-page-btn-description {
  background-color: #fff;
  padding: 1rem;
  max-width: 300px;
}

.header {
  box-shadow: none !important;

  &.is-transparent {
    background: transparent !important;
    box-shadow: none !important;
  }

  .v-breadcrumbs {
    li {
      .v-breadcrumbs__item {
        color: rgba(0, 0, 0, 0.38) !important;
      }

      &:last-child {
        .v-breadcrumbs__item {
          color: #2c3e50 !important;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .record_detail {
    .header {
      .back-btn {
        position: fixed !important;
        left: 12px;
        z-index: 10;
        background-color: #fff;
      }

      .v-toolbar__title {
        padding-left: 40px;
      }
    }
  }
}
</style>
